<template>
  <!-- accordion like settings-->

  <v-card class="fluid-column ma-5">

    <div v-if="runtimeStore.session.development?.active === true">
      <v-card-item>
        <v-card-title class="text-headline-small">Development options</v-card-title>
      </v-card-item>

      <v-card-text>
        <v-select v-model="runtimeStore.session.settings.chlorophyll_server_url"
            @update:model-value="runtimeStore.saveSession()" :items="chlorophyll_servers" label="Server Chlorophyll">
        </v-select>
        <v-select v-model="runtimeStore.session.settings.tracker_server_url"
            @update:model-value="runtimeStore.saveSession()" :items="pngptracker_servers" label="Server Tracker">
        </v-select>

      </v-card-text>
    </div>





    <div>

      <v-card-text>
        <p class="text-headline-small">Caratteri - dimensione</p>

        <p>
          Aumenta la dimensione base del carattere.
        </p>

        <v-slider v-model="runtimeStore.session.settings.fontSize" min="0" max="4" step=".5" thumb-label hide-details
            show-ticks="always" tick-size="4" @update:model-value="runtimeStore.saveSession">
          >
          <template v-slot:append>
            <span class="text-headline-large font-weight-light pl-10" v-text="runtimeStore.session.settings.fontSize"></span>
          </template>
        </v-slider>

      </v-card-text>
    </div>












    <v-card-text v-if="false">

      <p class="text-headline-small">Componenti</p>

      <v-switch v-model="runtimeStore.session.settings.showLocalSettingsBtn" hide-details color="success"
          @update:model-value="runtimeStore.saveSession" inset>
        <template v-slot:label>
          <div>
            <!-- <v-btn  
                  @click="runtimeStore.session.settings.showLocalSettingsBtn = !runtimeStore.session.settings.showLocalSettingsBtn"
                  variant="outlined" icon="mdi-cog" size="x-small" class="mx-1" color="blue-grey-darken-4" style="opacity: .6" /> -->


            <div v-if="runtimeStore.session.settings.showLocalSettingsBtn">
              <v-icon size="small" color="gray">mdi-eye</v-icon>
              Mostra impostazioni locali componenti
            </div>
            <div v-else>
              <v-icon size="small" color="gray">mdi-eye-off</v-icon>
              Nascondi impostazioni locali componenti
            </div>
          </div>
        </template>
      </v-switch>
      Rende visibile questo bottone
      <v-btn variant="flat" icon="mdi-cog" size="x-small" class="mx-1" color="blue-grey-darken-4"
          style="opacity: .6; scale: .7" />
      in alcuni punti dell'applicazione.<br>
      Premendolo è possibile accedere alle impostazioni locali dei componenti.
    </v-card-text>


    <v-card-text>
      <p class="text-headline-small">Server - invio dati</p>
      <v-switch v-model="runtimeStore.session.settings.uploadEnabled" hide-details color="success"
          @update:model-value="runtimeStore.saveSession" inset>
        <template v-slot:label>
          <v-icon size="small" color="grey-darken-2" class="mr-2">mdi-upload</v-icon>
          <span v-if="runtimeStore.session.settings.uploadEnabled">
            Upload abilitato
          </span>
          <span v-else>
            Upload disabilitato
          </span>
        </template>
      </v-switch>
      <!-- <v-divider />
      <p class="bg-grey-lighten-4 px-3 py-2 mt-5">
        <v-icon size="small" class="mr-4" color="green-darken-2">mdi-ethernet</v-icon>
        <v-icon size="small" class="mr-4" color="green-darken-2">mdi-wifi</v-icon>
        <v-icon size="small" class="mr-4"
            :color="runtimeStore.session.settings.uploadWithMobileConnection ? 'green-darken-2' : 'grey-lighten-1'">mdi-signal-5g</v-icon>
        <v-icon size="small" class="mr-4"
            :color="runtimeStore.session.settings.uploadWithMobileConnection ? 'green-darken-2' : 'grey-lighten-1'">mdi-signal-4g</v-icon>
        <v-icon size="small" class="mr-4"
            :color="runtimeStore.session.settings.uploadWithMobileConnection ? 'green-darken-2' : 'grey-lighten-1'">mdi-signal-3g</v-icon>
      </p>
      <v-radio-group color="primary" v-model="runtimeStore.session.settings.uploadWithMobileConnection" hide-details
          @update:model-value="runtimeStore.saveSession">
        <v-radio :value="true">
          <template v-slot:label>
            Permetti con qualsiasi connessione
          </template>
        </v-radio>
        <v-radio :value="false">
          <template v-slot:label>
            Permetti solo sotto copertura Wi-Fi / LAN
          </template></v-radio>
      </v-radio-group> -->
    </v-card-text>

    <v-card-text v-if="!disableNotifications">

      <p class="text-headline-small">Notifiche</p>

      <p class="my-4">
        Mostra le notifiche, per alcuni eventi.
      </p>
      <v-btn v-if="notificationGrantState == 'default'" @click="requestNotificationPermission" prepend-icon="mdi-bell"
          color="primary">
        Abilita </v-btn>

      <p v-if="notificationGrantState == 'denied'">
        <v-icon color="grey" size="small">mdi-bell</v-icon> Accesso alle notifiche negato dall'utente<v-icon
            color="red-darken-3" class="ml-1" size="small">mdi-close</v-icon><br>
        Per cambiare questa impostazione, accedere alle impostazioni dell'applicazione (a livello di browser/sistema
        operativo).
      </p>
      <ul>
        <li>Chrome: <a href="chrome://settings/content/notifications"
              target="_blank">chrome://settings/content/notifications</a></li>
        <li>Android: premere "a lungo" sull'icona dell'applicazione</li>
      </ul>

      <p v-if="notificationGrantState == 'granted'">
        <v-icon color="yellow-darken-3" size="small">mdi-bell</v-icon> Accesso alle notifiche autorizzato<v-icon
            color="green-darken-3" class="ml-1" size="default">mdi-check</v-icon>
      </p>
    </v-card-text>

    <v-card-text>
      <p class="text-headline-small">Suoni</p>

      <v-switch v-model="runtimeStore.session.settings.uiSoundEnabled" hide-details color="success"
          @update:model-value="runtimeStore.saveSession" inset>

        <template v-slot:label>
          <div>
            <v-icon size="small" color="grey-darken-2" class="mr-2">mdi-volume-high</v-icon>
            <span v-if="runtimeStore.session.settings.uiSoundEnabled">
              Suoni UI abilitati
            </span>
            <span v-else>
              Suoni UI disabilitati
            </span>
          </div>
        </template>
      </v-switch>
    </v-card-text>



    <v-card-text>
      <p class="text-headline-small">Accesso ai pacchetti aggiuntivi</p>


      <p class="mb-4">
        È possibile scegliere l'interfaccia per accedere ai contenuti aggiuntivi:<br>
      </p>  


      <v-radio-group color="primary" v-model="runtimeStore.session.settings.packsDownloadLocation" hide-details
          @update:model-value="runtimeStore.saveSession">



        <div>

          <strong>via Cached Requests</strong>

          <v-dialog width="auto" style="max-height: 90vh" >
            <template v-slot:activator="{ props }">
              <v-fab size="x-small" class="ml-2" variant="elevated" color="primary" v-bind="props"
                  icon="mdi-information-outline">
              </v-fab>
            </template>
            <template v-slot:default="{ isActive }">

              <v-card theme="dark">

              <v-card-item>
                <v-card-title>
                  <v-icon size="small" color="grey">mdi-memory</v-icon>
                  Cached Requests
                </v-card-title>
              </v-card-item>

                <v-card-text>

                  <ul class="pl-6">
                    <li>Opzione di default<v-icon size="x-small" class="mb-1 ml-2"
                          color="yellow-darken-2">mdi-star</v-icon></li>
                    <li>Non dipende da applcazioni terze.</li>
                    <li>Funziona sui dispositivi più recenti e compatibili.</li>
                    <li>Ha bisogno di hardware sufficientemente
                      potente e standard.</li>
                    <li>Memorizzazione interna (domain cache).</li>
                  </ul>

                  <p class="mt-2">
                    Compatibilità
                  </p>
                  <ul class="pl-6">
                    <li>
                      <v-icon size="small" color="grey-lighten-2">mdi-apple</v-icon> ios
                    </li>
                    <li>
                      <v-icon size="small" color="green">mdi-android</v-icon> android
                    </li>
                    <li>
                      <v-icon size="small" color="blue-lighten-1">mdi-desktop-classic</v-icon> desktop
                    </li>

                  </ul>

                </v-card-text>

                <v-card-actions class="d-flex flex-column align-center position-sticky bg-grey-darken-4 bottom-0" style="z-index:20001;">
                  <v-btn size="large" variant="outlined" color="white" @click="isActive.value = false"
                      class="mx-0 my-3">
                    <v-icon class="mr-2">mdi-chevron-down</v-icon>
                    Indietro</v-btn>
                </v-card-actions>
              </v-card>


            </template>
          </v-dialog>

        </div>

        <v-radio :value="'cache'">
          <template v-slot:label>
            <v-icon size="small" color="grey-darken-2" class="mr-2">mdi-memory</v-icon>
            Cached Requests
          </template>

        </v-radio>



        <div>
          <strong>
            via Web Server locale
            <v-dialog width="auto" style="max-height: 90vh" >

              <template v-slot:activator="{ props }">
                <v-fab size="x-small" class="ml-2" variant="elevated" color="primary" v-bind="props"
                    icon="mdi-information-outline">
                </v-fab>
              </template>
              <template v-slot:default="{ isActive }">

                <v-card theme="dark">


                  <v-card-item>
                    <v-card-title>
                      <v-icon size="small" color="grey">mdi-swap-vertical</v-icon>
                      Web Server locale
                    </v-card-title>
                  </v-card-item>

                  <v-card-text>

                    Questa opzione è disponibile utilizzando un web server compatibile installato localmente.<br>

                    <ul class="pl-6 mt-2">
                      <li>implica l'installazione di software terzo<br></li>
                      <li>comporta che i componenti aggiuntivi si trovino nelle corrette posizioni</li>
                    </ul>
                    <p class="mt-2">
                      Compatibilità
                    </p>
                    <ul class="pl-6">
                      <li>
                        <v-icon size="small" color="green">mdi-android</v-icon> android
                      </li>
                      <li>
                        <v-icon size="small" color="blue-lighten-1">mdi-desktop-classic</v-icon> desktop
                      </li>

                    </ul>
                    <v-dialog width="auto" style="max-height: 90vh" >
                      <template v-slot:activator="{ props }">
                        <v-btn class="mt-6" variant="elevated" color="primary" v-bind="props">
                          <template v-slot:prepend>
                            <v-icon>mdi-file-document</v-icon>
                          </template>
                          visualizza le istruzioni
                        </v-btn>
                      </template>
                      <template v-slot:default="{ isActive }">

                        <v-card theme="dark">

                          <v-card-title class="">Istruzioni</v-card-title>

                          <v-card-text>
                            <h3 class="my-2">1) Configurazione web server locale</h3>
                            Per poter accedere ai files è necessaria l'applicazione aggiuntiva<br>
                            <v-btn href="https://play.google.com/store/apps/details?id=com.phlox.simpleserver&hl=it"
                                target="_blank" rel="noopener" color="primary" class="ma-2">
                              <template v-slot:prepend>

                                <GooglePlayIcon size="20px" />
                              </template>
                              Simple HTTP
                              Server</v-btn>
                            <ul class="pl-6">
                              <li>Installare dal Google Play Store</li>
                              <li>Avviare e impostare come segue</li>
                            </ul>
                            <v-divider class="my-4" />
                            <ol class="pl-6">
                              <li>
                                <v-icon color="white">mdi-cog</v-icon> Port: <br>
                                Inserire: <span class="text-yellow">8080</span>
                              </li>

                              <li>
                                <v-icon color="white">mdi-cog</v-icon> root folder<br>

                                <ul class="pl-6">
                                  <li>
                                    Selezionare: <span class="text-yellow">"Storage Access
                                      Framework</span>
                                  </li>
                                  <li>
                                    Selezionare la cartella: <span
                                        class="text-yellow">/storage/0/emulated/.pngptracker</span>
                                  </li>
                                </ul>
                              </li>
                              <li>Selezionare<br>
                                <v-icon color="success">mdi-checkbox-marked-outline</v-icon>
                                Redirect to index.html if present<br>
                              </li>

                              <li>Selezionare<br>
                                <v-icon color="success">mdi-checkbox-marked-outline</v-icon>
                                Render folder content pages<br>
                              </li>

                              <li>Deselezionare<br>
                                <v-icon color="error">mdi-checkbox-blank-outline</v-icon>
                                Allow file uploading<br>
                              </li>

                              <li>
                                Restrict network interfaces<br>
                                Selezionare <strong>unicamente</strong><br>
                                <v-icon color="success">mdi-checkbox-marked-outline</v-icon>
                                <span class="text-yellow">lo -
                                  127.0.0.1</span><br>
                              </li>

                              <li>
                                Deselezionare <br>
                                <v-icon color="error">mdi-checkbox-blank-outline</v-icon>
                                White list of clients<br>
                              </li>

                              <li>
                                Deselezionare <br>
                                <v-icon color="error">mdi-checkbox-blank-outline</v-icon>
                                Use basic authentication<br>
                              </li>

                              <li>
                                Deselezionare <br>
                                <v-icon color="error">mdi-checkbox-blank-outline</v-icon>
                                Use TLS Encryption<br>
                              </li>

                              <li>
                                Selezionare <br>
                                <v-icon color="success">mdi-checkbox-marked-outline</v-icon>
                                Autostart on boot<br>
                              </li>

                              <li>
                                Custom response headers<br>
                                Selezionare e inserire<br>
                                <v-icon color="success">mdi-checkbox-marked-outline</v-icon>
                                Inserire: <br>
                                <span class="text-yellow">Access-Control-Allow-Origin: *</span><br>
                                <span class="text-yellow">Cross-Origin-Resource-Policy: cross-origin</span>
                                

                                <v-btn class="ml-4" size="x-small" color="yellow" @click="copy2clipboard(serverHeaders)" >
                                  <v-icon class="mr-2">mdi-content-copy</v-icon> copia
                                </v-btn><br>
                              </li>

                            </ol>


                            Una volta operate queste impostazioni, il web server sarà pronto per accettare le
                            richieste e
                            la
                            configurazione non dovrà più essere modificata.<br>
                            Questo è un link di test: <br>
                            <a href="http://localhost:8080" target="_blank" rel="noopener"
                                class="">http://localhost:8080</a><br>
                            Il server dovrebbe mostrare il contenuto della cartella
                            /storage/0/emulated/.pngptracker/
                            <br>

                            <v-divider class="mt-5" />
                            <h3 class="my-2">2) Posizionamento files</h3>

                            È necessario che i files siano presenti nei corretti percorsi.
                            <p class="text-yellow">
                              Probabilmente non vi sono operazioni
                              da eseguire.<br>
                              Il posizionamento su
                              filesystem è
                              lo stesso utilizzato nell'applicazione PNGP-Tracker.
                            </p>

                            <details class="mt-2">
                              <summary class="mb-2">
                                Dettaglio percorsi
                              </summary>
                              I file vanno posizionati nella cartella:
                              <pre class="text-lime">/storage
  /0
    /emulated
      /.pngptracker/</pre><br>
                              Nel dettaglio:<br>


                              <h3 class="my-2 mt-3">
                                Richiami
                              </h3>
                              <pre class="text-lime mb-2">/storage
  /0
    /emulated
      /.pngptracker
        /lures/</pre>

        <h3 class="my-2 mt-3">
                                Tiles piramide cartelle
                              </h3>
         <pre class="text-lime mb-2">/storage
  /0
    /emulated
      /.pngptracker
        /tiles/</pre>
                              <br>
                              È necessario creare le cartelle utilizzando il file manager del dispositivo.
                              
                            </details>
                          </v-card-text>

                          <v-card-actions class="d-flex flex-column align-center position-sticky bg-grey-darken-4 bottom-0" style="z-index:20001;">
                            <v-btn size="large" variant="outlined" color="white" @click="isActive.value = false"
                                class="mx-0 my-3">
                              <v-icon class="mr-2">mdi-chevron-down</v-icon>
                              Indietro</v-btn>
                          </v-card-actions>
                        </v-card>


                      </template>
                    </v-dialog>





                  </v-card-text>

                  <v-card-actions class="d-flex justify-center">
                    <v-btn size="large" variant="outlined" color="white" @click="isActive.value = false"
                        class="mx-0 my-3">
                      <v-icon class="mr-2">mdi-chevron-down</v-icon>
                      Indietro</v-btn>
                  </v-card-actions>
                </v-card>


              </template>
            </v-dialog>


          </strong>
        </div>

        <v-radio :value="'filesystem'">
          <template v-slot:label>
            <v-icon size="small" color="grey-darken-2" class="mr-2">mdi-swap-vertical</v-icon>
            Web Server locale
          </template>
        </v-radio>



      </v-radio-group>
      <p class="mt-6">
        L'interfaccia selezionata definisce la posizione in cui vengono scaricati i pacchetti.<br>
        La posizione attualmente selezionata è:
      </p>
      <p 
          :class="runtimeStore.session.settings.packsDownloadLocation === 'cache' ? 'font-weight-bold' : 'text-grey'">
          <v-icon class="mr-2">mdi-arrow-right </v-icon>
          cache delle richieste (cache del browser)
      </p>
      <p 
          :class="runtimeStore.session.settings.packsDownloadLocation === 'filesystem' ? 'font-weight-bold' : 'text-grey'">
          <v-icon class="mr-2">mdi-arrow-right </v-icon>
          filesystem
      </p>

    </v-card-text>




    <v-card-text
        v-if="(packsStore.isBackgroundFetchSupported && runtimeStore.session.settings.packsDownloadLocation === 'cache') || ENVIRONMENT == 'development'">
      <p class="text-headline-small">Modalità download</p>

      <p>
        Il tuo dispositivo supporta il download in background.
      </p>
      <p class="font-weight-bold" v-if="ENVIRONMENT == 'development'">
        <br>
        Non supporta adesso il download in background , perché siamo in development.<br>
        Non supporta adesso la posizione di download "cache", perché siamo in development.<br>
        Non supporta adesso la posizione di download "opfs", perché siamo in development.<br>
      </p>

      <v-radio-group color="primary" v-model="runtimeStore.session.settings.backgroundFetchUserDisabled" hide-details
          @update:model-value="runtimeStore.saveSession">
        <v-radio :value="true">
          <template v-slot:label>
            Usa il download normale
          </template>
        </v-radio>
        <v-radio :value="false">
          <template v-slot:label>
            Usa la modalità in background
          </template></v-radio>
      </v-radio-group>


      <p>
        Con l'opzione <a href="https://developer.mozilla.org/en-US/docs/Web/API/Background_Fetch_API"
            target="_blank">backgroundFetch</a>, i pacchetti vengono scaricati anche mentre l'applicazione è
        chiusa.<br>
        Con il download normale, lo scaricamento avviene solo mentre l'applicazione sta funzionando ed è in primo piano.
      </p>

    </v-card-text>




    <v-card-text>
      <p class="text-headline-small">Ripristina</p>
      Ripristina le impostazioni come al primo avvio.<br>
      Può essere utile se si riscontrano problemi di funzionamento.<br>

      <v-btn prepend-icon="mdi-restart" class="mt-2 mb-4" color="blue-darken-3">
        Ripristina

        <v-dialog v-model="dialogResetSettings" activator="parent" width="auto" theme="dark">
          <v-card>
            <v-card-item>
              <v-card-title> Ripristina impostazioni</v-card-title>
              <v-card-subtitle>Stai per ripristinare le impostazioni.</v-card-subtitle>
            </v-card-item>
            <v-card-text>
              <p>
                Sei davvero sicuro di voler continuare?
              </p>
            </v-card-text>

            <v-card-actions class="flex-column">
              <v-btn class="pl-2" size="large" variant="elevated" color="success" @click="resetSettings">
                <v-icon class="mr-2">mdi-check</v-icon>
                Conferma</v-btn>
              <v-btn size="large" variant="outlined" color="white" @click="dialogResetSettings = false"
                  class="mx-0 my-3">
                <v-icon class="mr-2">mdi-chevron-down</v-icon>
                Indietro</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-btn>
    </v-card-text>


    <div class="pb-6">
      <v-card-text>
        <p class="text-headline-small">Dispositivo</p>
        <pre>id: {{ deviceId }}</pre>

        <v-dialog width="auto" theme="dark">
          <template v-slot:activator="{ props }">
            <div class="mb-2">
              <v-btn v-bind="props" prepend-icon="mdi-information-outline" class="my-4" color="blue-darken-3" >
                Dettaglio
              </v-btn>
            </div>
          </template>
          <template v-slot:default="{ isActive }">
            <v-card>
              <v-card-item>
                <v-card-title> Dettaglio dispositivo</v-card-title>
              </v-card-item>

              <v-card-text>
                <p class="mt-5 mb-3">Identificazione - device.uainfoe</p>
                <pre>{{ uainfo }}</pre>
                <p class="mt-5 mb-3">Network</p>
                <pre>{{ networkData }}</pre>
              </v-card-text>

              <v-card-actions class="flex-column">
                <v-btn size="default" variant="outlined" color="white" @click="isActive.value = false"
                    class="mx-0 my-3">
                  <v-icon class="mr-2">mdi-chevron-down</v-icon>
                  Indietro</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>


      </v-card-text>

    </div>


  </v-card>
</template>

<script setup>

import router from "@/router";
import { useI18n } from "vue-i18n";
import { useRuntimeStore } from "@/store/runtime"
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useDataStore } from "@/store/data"

import { useNetworkStore } from "@/store/network"
import { usePacksStore } from "@/store/packs"
import { passwordStrength } from 'check-password-strength'

import { FirefoxIcon, SafariIcon, GoogleChromeIcon } from 'vue3-simple-icons'
import { GooglePlayIcon } from 'vue3-simple-icons'


import { useToastsStore } from "@/store/toasts";

// import cg from "@/service/colorGenerator";

import { useApi } from "@/service/api";

import { useDevice } from "@/service/device"

import { useCopyToClipboard } from "@/service/copyToClipboard";
const { copy2clipboard } = useCopyToClipboard();

const device = useDevice()
const deviceId = device.id
const uainfo = device.uainfo

const toastsStore = useToastsStore();

const serverHeaders = "Access-Control-Allow-Origin: *\nCross-Origin-Resource-Policy: cross-origin"

// import { getUserAgent } from "universal-user-agent"
// import { UAParser } from "ua-parser-js"

// const getDevice = () => {
//   const userAgent = getUserAgent()
//   let parser = new UAParser(userAgent); // you need to pass the user-agent for nodejs
//   // console.log(parser); // {}
//   let device = parser.getResult();
//   console.log(device);
//   // create a readable string from the device object
//   return device;
// }

// const getDeviceId = () => {
//   let device = getDevice();
//   console.log(device);
//   let deviceId = `${device?.browser?.name}@${device?.os?.name}_${device?.os?.version}_${device?.cpu?.architecture}`
//   // return device;
//   return deviceId;
// }

// const device = ref(getDevice())
// const deviceId = ref(getDeviceId())
const accordion = ref(0);


const showDeepInfos = ref(false)

const new_username_to_connect_as = ref("mainetti_a")
const newUserData = ref({})

const api = useApi()
const networkStore = useNetworkStore();
const packsStore = usePacksStore();

const dataStore = useDataStore();

const online = ref(false);

const usernameConfirmation = ref("");





window.ononline = function () {
  online.value = true;
}

window.onoffline = function () {
  online.value = false;
}



const dialogImpersonate = ref(false);

const getUserAuth = async () => {
  const result = await api.tracker.getUserAuth(new_username_to_connect_as.value)
  newUserData.value = result.data
}

const useAuthUserData = () => {
  console.log(newUserData.value.user)
  runtimeStore.saveUserData(newUserData.value.user)

  dialogImpersonate.value = false
  toastsStore.toast({
    title: 'Account',
    text: 'nuovo utente',
    type: 'success',
  })
}


// const { t, locale } = useI18n({
// });

const { t } = useI18n({
});


const testTokenStatus = ref({
  result: false,
  iconColor: '',
  iconText: '',
  title: '',
  text: '',
})


const chgpwd = ref({
  old_password: '',
  new_password: '',
  new_password_repeat: '',
})


const showNewPwd = ref(false)
const showOldPwd = ref(false)


const passwordQuality = computed(() => {
  return passwordStrength(chgpwd.value.new_password).id
})

const checkPasswordButtonEnabled = () => {
  if (passwordQuality.value < 2) {
    console.log("password debole")
    return false
  }
  if (chgpwd.value.new_password == chgpwd.value.old_password) {
    console.log("nuova uguale vecchia")
    return false
  }
  if (chgpwd.value.new_password != chgpwd.value.new_password_repeat) {
    console.log("password diverse")
    return false
  }

  return true
}

const passwordButtonEnabled = computed(() => {
  return checkPasswordButtonEnabled()
})


const submitChangePasswordRequest = async () => {
  console.log("submitChangePasswordRequest fired")
  const data = {
    "old": chgpwd.value.old_password,
    "new": chgpwd.value.new_password,
  }
  const result = await api.tracker.userChangePassword(data)

  console.log(result)

  if (result?.success) {
    console.log(result.message)
  }
  else {
    console.log(result.message)
  }

  dialogPassword.value = false
}


const runtimeStore = useRuntimeStore();

const dialogLogout = ref(false);
const dialogDeleteAllUserData = ref(false);
const dialogResetSettings = ref(false);

const dialogPassword = ref(false);

const lockLogout = ref(false);

const logoutClicked = async () => {

  lockLogout.value = true

  const logoutResult = await api.tracker.logout()

  console.log(logoutResult)
  if (logoutResult.response === undefined) {
    const text = `Sta per avvenire la disconnessione.
    
    Non è stato possibile comunicare con il server.
    Per invalidare l'attuale token con cui è collegato il dispositivo,
    eliminarlo manualmente tramite l'interfaccia di gestione autenticazioni.
    Se il token non verrà utilizzato per 60 giorni, decadrà automaticamente.
    `
    toastsStore.toast({
      title: 'Logout',
      text: text,
      type: 'warning',
      showUICountdown: true,
      duration: 20000,
      callbackOnHide: logoutOperations
    })
    return
  }

  if (logoutResult?.data?.success === true) {
    logoutOperations()
  }

  if (logoutResult.response.status === 401) {
    logoutOperations()
  }


}


const logoutOperations = async () => {
  lockLogout.value = false
  // console.log("adesso effettuo il logout")
  // return
  // console.log("logout result", result)
  runtimeStore.logout();
  dialogLogout.value = false;
  router.push({ name: 'login' })
}


const chlorophyll_servers = [
  {
    title: 'Development 8100',
    value: 'http://localhost:8100',
  },
  {
    title: 'Staging',
    value: 'https://chlorophyll-staging.pngp.it',
  },
  {
    title: 'Production',
    value: 'https://chlorophyll.pngp.it',
  },
]

const pngptracker_servers = [
  {
    title: 'Development 8100',
    value: 'http://localhost:8100',
  },
  {
    title: 'Staging',
    value: 'https://tracker-staging.pngp.it',
  },
  {
    title: 'Production',
    value: 'https://tracker.pngp.it',
  },
]


// const languages = [
//   {
//     title: 'Italiano',
//     value: 'it',
//   },
//   {
//     title: 'English',
//     value: 'en',
//   },
//   {
//     title: 'Français',
//     value: 'fr',
//   },
// ]

const resetSettings = () => {
  runtimeStore.resetSettings()
  dialogResetSettings.value = false
  window.location.reload()

  // router.push({name:'settings'})
}

const deleteUserData = () => {
  dataStore.deleteUserData()
  dialogDeleteAllUserData.value = false
  window.location.reload()

  // router.push({name:'settings'})
}

const requestNotificationPermission = () => {
  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      new Notification("Notifiche abilitate", {
        body: "Hai abilitato le notifiche per l'applicatione.",
        icon: "put/icon/here",
      });
      setTimeout(() => {
        console.log("🔔 notificationGrantState", notificationGrantState)
        clearInterval(notificationGrantStateInterval)
      }, 400);
    }
  });
}


const disableNotifications = ref(true)
// per ora sono inutli


const notificationGrantState = ref(false)

let notificationGrantStateInterval = null

onMounted(() => {
  notificationGrantStateInterval = setInterval(() => {
    notificationGrantState.value = Notification.permission
  }, 1500);

  online.value = navigator.onLine;

  setTimeout(secure_data_test_get, 300)

})




onUnmounted(() => {
  clearInterval(notificationGrantStateInterval)

})



const secure_data_test_get = async () => {

  console.log("🧠 testToken against tracker api")

  testTokenStatus.value.result = false
  testTokenStatus.value.iconColor = "red-darken-2"
  testTokenStatus.value.iconText = "mdi-dots-circle mdi-spin"
  testTokenStatus.value.title = "Controllo in corso"
  testTokenStatus.value.text = "Attendere..."

  if (!networkStore.online) {
    testTokenStatus.value.result = false
    testTokenStatus.value.iconColor = "grey-darken-2"
    testTokenStatus.value.iconText = "mdi-wifi-off"
    testTokenStatus.value.title = "Offline"
    testTokenStatus.value.text = "Non è possibile effettuare il controllo"
    return
  }



  if (networkStore.trackerServerStatus === false) {
    testTokenStatus.value.result = false
    testTokenStatus.value.iconColor = "grey-darken-2"
    testTokenStatus.value.iconText = "mdi-server-off"
    testTokenStatus.value.title = "Server non raggiungibile"
    testTokenStatus.value.text = "Non è possibile raggiungere il server, per validare l'autenticazione"
    return
  }


  const result = await api.tracker.sdtg()

  console.log(result)

  if (result?.response) {

    if (result?.response?.status >= 200 && result?.response?.status < 300) {
      testTokenStatus.value.result = true
      testTokenStatus.value.iconColor = "green-darken-2"
      testTokenStatus.value.iconText = "mdi-check"
      testTokenStatus.value.title = "Autenticazione riconosciuta"
      testTokenStatus.value.text = "L'applicazione può comunicare con il server."
    }
    else {
      testTokenStatus.value.result = false
      testTokenStatus.value.iconColor = "orange-darken-2"
      testTokenStatus.value.iconText = "mdi-alert"
      testTokenStatus.value.title = "Token non valido"
      testTokenStatus.value.text = "L'applicazione non può comunicare con il server.<br>È necessario effettuare nuovamente il login."
    }
  }


}


const networkData = {};
for (const key in navigator.connection) {
  if (typeof navigator.connection[key] !== "function") {
    networkData[key] = navigator.connection[key];
  }
}
console.log(JSON.stringify(networkData));
console.log(networkData);


</script>

<style scoped>
#fluidColumn {
  column-gap: 4em;
  column-width: 32em;
  column-count: auto;
  column-rule: 1px solid #ddd;
  /* column-count: 3; */
  widows: 3;
  orphans: 3;
}

.disable-events {
  pointer-events: none;
  opacity: .8;
}
</style>
